import Layout from 'components/ui/Layout';
import { useBookings } from 'features/booking/hooks/useBookings';
import { usePrefetchBookings } from 'features/booking/hooks/usePrefetchBookings';
import {
  Calendar,
  ChevronLeft,
  ChevronRight,
  Download,
  Eye,
  IndianRupee,
  Package,
  User,
} from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { formatDateTime } from 'utils/dateFormatter';
import {
 useMainCategories
}
from
'features/main-category/hooks/useMainCategories';

import { useUserProfile } from 'features/auth/hooks/useUserProfile';
import bookingServices  from 'features/booking/services/booking.service';

import { useSubCategories } from 'features/sub-category/hooks/useSubCategories';

const Booking = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { prefetchNextPage, prefetchBooking } = usePrefetchBookings();

  // Get initial values from URL params
  const initialPage = parseInt(searchParams.get('page')) || 1;
  const initialLimit = parseInt(searchParams.get('limit')) || 10;
  const initialStatus = searchParams.get('status') || '';
  const initialBookingType = searchParams.get('bookingType') || '';
  const initialPaymentStatus = searchParams.get('paymentStatus') || '';
  
  const initialStartDate = searchParams.get('startDate') || '';
const initialEndDate = searchParams.get('endDate') || '';

const initialCategoryId =
searchParams.get(
 'categoryId'
) || '';

const initialSubcategoryId =
  searchParams.get('subcategoryId') || '';

  const [page, setPage] = useState(initialPage);
  const [limit, setLimit] = useState(initialLimit);
  const [status, setStatus] = useState(initialStatus);
  const [bookingType, setBookingType] = useState(initialBookingType);
  const [paymentStatus, setPaymentStatus] = useState(initialPaymentStatus);

  const [startDate, setStartDate] = useState(initialStartDate);
const [endDate, setEndDate] = useState(initialEndDate);

const [

 categoryId,

 setCategoryId

]

=

useState(

 initialCategoryId

);

const [
  subcategoryId,
  setSubcategoryId,
] = useState(initialSubcategoryId);

const initialSortBy =
  searchParams.get("sortBy") || "createdAt";

const initialSortOrder =
  searchParams.get("sortOrder") || "desc";

const [sortBy, setSortBy] =
  useState(initialSortBy);

const [sortOrder, setSortOrder] =
  useState(initialSortOrder);

 const { data: profileData } = useUserProfile();
const user = profileData?.data;

const restrictedRoles = ["category_manager", "finance_manager"];

const showPermissionError = restrictedRoles.includes(
  user?.role?.name
);

const hideCategoryFilters = [
  "delivery_manager",
  "travel_manager",
].includes(user?.role?.name);


let filters = {};

if(user?.role?.name === "delivery_manager"){
  filters = {

 page,

 limit,

 status:
 status ||

 undefined,

 bookingType:
 bookingType ||

 undefined,

 paymentStatus:
 paymentStatus ||

 undefined,


 categoryId:

 categoryId ||

 undefined,


 customerId:
 undefined,


 sellerId:
 undefined,


 serviceId:
 undefined,


 assignedStaffId:
 undefined,


 startDate:
 startDate ||

 undefined,


 endDate:
 endDate ||

 undefined,


 search:
 undefined,


 sortBy,

sortOrder,

 type: 'food'

};
}else if(user?.role?.name === "travel_manager"){
  filters = {

 page,

 limit,

 status:
 status ||

 undefined,

 bookingType:
 bookingType ||

 undefined,

 paymentStatus:
 paymentStatus ||

 undefined,


 categoryId:

 categoryId ||

 undefined,


 customerId:
 undefined,


 sellerId:
 undefined,


 serviceId:
 undefined,


 assignedStaffId:
 undefined,


 startDate:
 startDate ||

 undefined,


 endDate:
 endDate ||

 undefined,


 search:
 undefined,


 sortBy,

sortOrder,

 type: 'tour'

};
}else{
    filters = {

 page,

 limit,

 status:
 status ||

 undefined,

 bookingType:
 bookingType ||

 undefined,

 paymentStatus:
 paymentStatus ||

 undefined,


 categoryId:

 categoryId ||

 undefined,

 subcategoryId:
  subcategoryId || undefined,


 customerId:
 undefined,


 sellerId:
 undefined,


 serviceId:
 undefined,


 assignedStaffId:
 undefined,


 startDate:
 startDate ||

 undefined,


 endDate:
 endDate ||

 undefined,


 search:
 undefined,


sortBy,

sortOrder,
};
}
 

  // Fetch bookings
  const { data: response, isLoading, isError, error } = useBookings(filters);

 
  const {

 data:
 categoryResponse

}

=

useMainCategories({

 limit:100

});

const categories =

categoryResponse?.data

||

[];


// console.log("returned main categories:", categories)
const { data: subCategoryResponse } = useSubCategories({
  page: 1,
  limit: 100,
  parentCategory: categoryId || undefined,
});



const subcategories =
  subCategoryResponse?.data || [];

  const bookings = response?.data || [];
  const pagination = response?.pagination || {};


 const handleExport = async () => {
  try {
    const response =
      await bookingServices.exportBookings(
        filters
      );

    const blob = new Blob(
      [response.data],
      {
        type: 'text/csv',
      }
    );

    const url =
      window.URL.createObjectURL(
        blob
      );

    const link =
      document.createElement('a');

    link.href = url;

    link.download = `bookings-${Date.now()}.csv`;

    document.body.appendChild(
      link
    );

    link.click();

    document.body.removeChild(
      link
    );

    window.URL.revokeObjectURL(
      url
    );
  } catch (error) {
    console.error(
      'Failed to export bookings',
      error
    );
  }
};

  // Update URL params when filters change
  // useEffect(() => {
  //   const params = new URLSearchParams();
  //   params.set('page', page);
  //   params.set('limit', limit);
  //   if (status) params.set('status', status);
  //   if (bookingType) params.set('bookingType', bookingType);
  //   if (paymentStatus) params.set('paymentStatus', paymentStatus);
  //   setSearchParams(params);
  // }, [page, limit, status, bookingType, paymentStatus, setSearchParams]);

useEffect(() => {
  const params = new URLSearchParams();

  params.set("page", page);
  params.set("limit", limit);

  if (status)
    params.set("status", status);

  if (bookingType)
    params.set("bookingType", bookingType);

  if (paymentStatus)
    params.set(
      "paymentStatus",
      paymentStatus
    );

  if (startDate)
    params.set(
      "startDate",
      startDate
    );

  if (endDate)
    params.set(
      "endDate",
      endDate
    );

  if (categoryId)
    params.set(
      "categoryId",
      categoryId
    );

  if (subcategoryId)
    params.set(
      "subcategoryId",
      subcategoryId
    );

  params.set(
    "sortBy",
    sortBy
  );

  params.set(
    "sortOrder",
    sortOrder
  );

  setSearchParams(params);

},[
  page,
  limit,
  status,
  bookingType,
  paymentStatus,
  startDate,
  endDate,
  categoryId,
  subcategoryId,
  sortBy,
  sortOrder,
  setSearchParams,
]);

  // Prefetch next page
  useEffect(() => {
    if (response?.pagination) {
      const { currentPage, totalPages } = response.pagination;
      if (currentPage < totalPages) {
        prefetchNextPage(filters, totalPages);
      }
    }
  }, [response, filters]);

  const handleViewClick = (booking) => {
    navigate(`/bookings/${booking._id}`);
  };

  const handleFilterChange = (filterType, value) => {
    setPage(1); // Reset to page 1 when filters change
    switch (filterType) {
      case "status":
        setStatus(value);
        break;
      case "bookingType":
        setBookingType(value);
        break;
      case "paymentStatus":
        setPaymentStatus(value);
        break;
      case "categoryId":
        setCategoryId(value);
        setSubcategoryId(""); // Clear previously selected subcategory
        break;

      case "subcategoryId":
        setSubcategoryId(value);
        break;
      default:
        break;
    }
  };

  const handleDateChange = (type, value) => {
  setPage(1);

  if (type === 'startDate') {
    setStartDate(value);
  }

  if (type === 'endDate') {
    setEndDate(value);
  }
};

  const handlePageChange = (newPage) => {
    setPage(newPage);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSort = (column) => {
  const newOrder =
    sortBy === column &&
    sortOrder === "asc"
      ? "desc"
      : "asc";

  setSortBy(column);
  setSortOrder(newOrder);
  setPage(1);
};

const SortIcon = ({ column }) => {
  if (sortBy !== column) {
    return (
      <span className="text-gray-400">
        ↕
      </span>
    );
  }

  return sortOrder === "asc"
    ? <span>↑</span>
    : <span>↓</span>;
};

  const getStatusColor = (status) => {
    const colors = {
      pending: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
      confirmed: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
      in_progress: 'bg-purple-500/10 text-purple-600 dark:text-purple-400',
      completed: 'bg-green-500/10 text-green-600 dark:text-green-400',
      cancelled: 'bg-red-500/10 text-red-600 dark:text-red-400',
      rescheduled: 'bg-orange-500/10 text-orange-600 dark:text-orange-400',
      rejected: 'bg-gray-500/10 text-gray-600 dark:text-gray-400',
    };
    return colors[status] || 'bg-gray-500/10 text-gray-600 dark:text-gray-400';
  };

  const getPaymentStatusColor = (status) => {
    const colors = {
      pending: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400',
      processing: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
      completed: 'bg-green-500/10 text-green-600 dark:text-green-400',
      failed: 'bg-red-500/10 text-red-600 dark:text-red-400',
      refunded: 'bg-purple-500/10 text-purple-600 dark:text-purple-400',
      partially_refunded:
        'bg-orange-500/10 text-orange-600 dark:text-orange-400',
    };
    return colors[status] || 'bg-gray-500/10 text-gray-600 dark:text-gray-400';
  };

  if (isError) {
    return (
      <Layout>
        <div className='flex flex-col items-center justify-center h-screen'>
          <div className='text-destructive text-lg mb-4'>
            Error loading bookings
          </div>
          <p className='text-muted-foreground'>
            {error?.message || 'Something went wrong'}
          </p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="p-6 space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold flex items-center gap-2">
              <Calendar className="text-primary" size={32} />
              Bookings
            </h1>
            <p className="text-muted-foreground mt-1">
              Manage all service bookings.
            </p>
          </div>

          {!showPermissionError && (
            <button
              onClick={handleExport}
              className="flex items-center space-x-2 px-4 py-2 text-sm border border-border rounded-md bg-card text-card-foreground hover:bg-accent transition-colors"
            >
              <Download size={16} />
              <span>Export</span>
            </button>
          )}
        </div>

        {/* Filters */}
        <div className="bg-card border border-border rounded-lg p-4">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
            <div className="w-full flex gap-3">
              {/* Status Filter */}
              <div className="flex-1">
                <label className="block text-sm font-medium mb-2">Status</label>
                <select
                  value={status}
                  onChange={(e) => handleFilterChange("status", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background"
                >
                  <option value="">All Statuses</option>
                  <option value="pending">Pending</option>
                  <option value="confirmed">Confirmed</option>
                  <option value="in_progress">In Progress</option>
                  <option value="completed">Completed</option>
                  <option value="cancelled">Cancelled</option>
                  <option value="rescheduled">Rescheduled</option>
                  <option value="rejected">Rejected</option>
                </select>
              </div>

              {/* Booking Type Filter */}
              <div className="flex-1">
                <label className="block text-sm font-medium mb-2">
                  Booking Type
                </label>
                <select
                  value={bookingType}
                  onChange={(e) =>
                    handleFilterChange("bookingType", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background"
                >
                  <option value="">All Types</option>
                  <option value="instant">Instant</option>
                  <option value="schedule">Schedule</option>
                </select>
              </div>
            </div>

            {/* Payment Status Filter */}
            <div>
              <label className="block text-sm font-medium mb-2">
                Payment Status
              </label>
              <select
                value={paymentStatus}
                onChange={(e) =>
                  handleFilterChange("paymentStatus", e.target.value)
                }
                className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background"
              >
                <option value="">All Payment Statuses</option>
                <option value="pending">Pending</option>
                <option value="processing">Processing</option>
                <option value="completed">Completed</option>
                <option value="failed">Failed</option>
                <option value="refunded">Refunded</option>
                <option value="partially_refunded">Partially Refunded</option>
              </select>
            </div>


{/* category wise filter */}
           {!hideCategoryFilters && ( <div>
              <label
                className="

block

text-sm

font-medium

mb-2

"
              >
                Category
              </label>

              <select
                value={categoryId}
                onChange={(e) =>
                  handleFilterChange(
                    "categoryId",

                    e.target.value,
                  )
                }
                className="

 w-full

 px-3

 py-2

 text-sm

 border

 border-border

 rounded-md

 bg-background

 "
              >
                <option value="">All Categories</option>

                {/* certain categories excluded from the filter list due to special case */}
                {/* {

 categories.map(

   (

    category

   )=>(


<option

 key={

   category._id

 }


 value={

   category._id

 }

>

{

 category.name

 ?.english

}


</option>


)

)

} */}

                {categories
                  .filter(
                    (category) =>
                      !["find-jobs", "property-and-real-estate"].includes(
                        category.slug,
                      ),
                  )
                  .map((category) => (
                    <option key={category._id} value={category._id}>
                      {category.name?.english}
                    </option>
                  ))}
              </select>
            </div>)}


{/* sub category wise filter */}
            {!hideCategoryFilters && (<div>
              <label className="block text-sm font-medium mb-2">
                Sub Category
              </label>

              <select
                value={subcategoryId}
                onChange={(e) =>
                  handleFilterChange("subcategoryId", e.target.value)
                }
                className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background"
                disabled={!categoryId}
              >
                <option value="">All Sub Categories</option>

                {subcategories.map((subcategory) => (
                  <option key={subcategory._id} value={subcategory._id}>
                    {subcategory.name?.english}
                  </option>
                ))}
              </select>
            </div>)}

            {/* Start Date */}
            <div className="flex-1">
              <label className="block text-sm font-medium mb-2">
                Start Date
              </label>

              <input
                type="date"
                value={startDate}
                onChange={(e) => handleDateChange("startDate", e.target.value)}
                className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background"
              />
            </div>
            <div className="_w-full flex gap-3">
              {/* End Date */}
              <div className="flex-1">
                <label className="block text-sm font-medium mb-2">
                  End Date
                </label>

                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => handleDateChange("endDate", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background"
                />
              </div>

              {/* Items Per Page */}
              <div>
                <label className="block text-sm font-medium mb-2">
                  Items Per Page
                </label>
                <select
                  value={limit}
                  onChange={(e) => {
                    setLimit(parseInt(e.target.value));
                    setPage(1);
                  }}
                  className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="bg-card border border-border rounded-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-muted border-b border-border">
                <tr>
                  {/* <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Booking #
                  </th> */}
                  <th
  className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider cursor-pointer hover:text-foreground"
  onClick={() => handleSort("bookingNumber")}
>
  <div className="flex items-center space-x-1">
    <span>Booking #</span>
    <SortIcon column="bookingNumber" />
  </div>
</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Customer
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Service Provider
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Service/Tour
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Category
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Sub-Category
                  </th>
                  {/* <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Type
                  </th> */}
                  <th
  className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider cursor-pointer hover:text-foreground"
  onClick={() => handleSort("bookingType")}
>
  <div className="flex items-center space-x-1">
    <span>Type</span>
    <SortIcon column="bookingType" />
  </div>
</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Amount
                  </th>
                  {/* <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Payment Status
                  </th> */}

                  <th
  className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider cursor-pointer hover:text-foreground"
  onClick={() =>
    handleSort("payment.paymentStatus")
  }
>
  <div className="flex items-center space-x-1">
    <span>Payment Status</span>
    <SortIcon column="payment.paymentStatus" />
  </div>
</th>
                  {/* <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Status
                  </th> */}

                  <th
  className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider cursor-pointer hover:text-foreground"
  onClick={() => handleSort("status")}
>
  <div className="flex items-center space-x-1">
    <span>Status</span>
    <SortIcon column="status" />
  </div>
</th>
                  {/* <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Created At
                  </th> */}
                  <th
  className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider cursor-pointer hover:text-foreground"
  onClick={() => handleSort("createdAt")}
>
  <div className="flex items-center space-x-1">
    <span>Created At</span>
    <SortIcon column="createdAt" />
  </div>
</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {showPermissionError ? (
                  <tr>
                    <td
                      colSpan="11"
                      className="px-4 py-8 text-center text-destructive"
                    >
                      Error loading bookings: You do not have permission to
                      perform this action!
                    </td>
                  </tr>
                ) : isLoading ? (
                  <tr>
                    <td colSpan="10" className="px-4 py-8 text-center">
                      <div className="flex items-center justify-center">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
                      </div>
                    </td>
                  </tr>
                ) : bookings.length === 0 ? (
                  <tr>
                    <td
                      colSpan="10"
                      className="px-4 py-8 text-center text-muted-foreground"
                    >
                      No bookings found
                    </td>
                  </tr>
                ) : (
                  bookings.map((booking) => (
                    <tr
                      key={booking._id}
                      className="hover:bg-muted/50 transition-colors"
                    >
                      <td className="px-4 py-3">
                        <span className="text-sm font-medium text-primary">
                          #{booking.bookingNumber}
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex items-center space-x-3">
                          {booking.customerId?.profilePhoto ? (
                            <img
                              src={booking.customerId.profilePhoto}
                              alt="Customer"
                              className="w-8 h-8 rounded-full object-cover"
                            />
                          ) : (
                            <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                              <User size={16} />
                            </div>
                          )}
                          <div>
                            <p className="text-sm font-medium whitespace-nowrap">
                              {booking.customerId?.firstName || "--"}{" "}
                              {booking.customerId?.lastName || "--"}
                            </p>
                            <p className="text-sm font-medium whitespace-nowrap">
                              {booking.customerId?.phoneNumber || "--"}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex items-center space-x-3">
                          {booking.sellerId?.profilePhoto ? (
                            <img
                              src={booking.sellerId.profilePhoto}
                              alt="Seller"
                              className="w-8 h-8 rounded-full object-cover"
                            />
                          ) : (
                            <div className="w-8 h-8 rounded-full bg-purple-500/10 flex items-center justify-center">
                              <User size={16} />
                            </div>
                          )}
                          <div>
                            <p className="text-sm font-medium whitespace-nowrap">
                              {booking.sellerId?.firstName || "--"}{" "}
                              {booking.sellerId?.lastName || "--"}
                            </p>
                            <p className="text-sm font-medium whitespace-nowrap">
                              {booking.sellerId?.phoneNumber || "--"}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2">
                          <Package
                            size={16}
                            className="text-muted-foreground"
                          />
                          <span className="text-sm whitespace-nowrap">
                            {booking?.serviceId?.name ||
                              booking?.tourId?.title ||
                              booking?.sellerId?.restaurantName ||
                              "--"}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2">
                          {/* <Package
                            size={16}
                            className='text-muted-foreground'
                          /> */}
                          <span className="text-sm whitespace-nowrap">
                            {booking?.serviceId?.categoryId?.name?.english ||
                              booking.tourId?.categoryId?.name?.english ||
                              booking.type?.charAt(0).toUpperCase() +
                                booking.type?.slice(1) ||
                              "--"}
                          </span>
                        </div>
                      </td>

                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2">
                          {/* <Package
                            size={16}
                            className='text-muted-foreground'
                          /> */}
                          <span className="text-sm whitespace-nowrap">
                            {booking?.serviceId?.subcategoryId?.name?.english ||
                              booking?.tourId?.subcategoryId?.name?.english ||
                              booking?.foodItems
                                ?.map(
                                  (item) => item?.subcategoryId?.name?.english,
                                )
                                .filter(Boolean)
                                .join(", ") ||
                              "--"}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <span className="text-sm capitalize">
                          {booking.bookingType?.replace(/_/g, " ")}
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-1">
                          <IndianRupee
                            size={14}
                            className="text-muted-foreground"
                          />
                          <span className="text-sm font-medium">
                            {booking.pricing?.totalAmount?.toFixed(2)}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <span
                          className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getPaymentStatusColor(
                            booking.payment?.paymentStatus,
                          )}`}
                        >
                          {booking.payment?.paymentStatus
                            ?.replace(/_/g, " ")
                            ?.toUpperCase()}
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <span
                          className={`inline-flex px-2 py-1 text-xs font-medium rounded-full whitespace-nowrap ${getStatusColor(
                            booking.status,
                          )}`}
                        >
                          {booking.status?.replace(/_/g, " ")?.toUpperCase()}
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <span className="text-sm text-muted-foreground">
                          {formatDateTime(booking.createdAt)}
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <button
                          onClick={() => handleViewClick(booking)}
                          onMouseEnter={() => prefetchBooking(booking._id)}
                          className="inline-flex items-center px-3 py-1 text-sm bg-primary/10 text-primary rounded-md hover:bg-primary/20 transition-colors"
                        >
                          <Eye size={14} className="mr-1" />
                          View
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {!showPermissionError && pagination.totalPages > 1 && (
            <div className="px-4 py-3 border-t border-border flex items-center justify-between">
              <div className="text-sm text-muted-foreground">
                Showing{" "}
                {(pagination.currentPage - 1) * pagination.itemsPerPage + 1} to{" "}
                {Math.min(
                  pagination.currentPage * pagination.itemsPerPage,
                  pagination.totalItems,
                )}{" "}
                of {pagination.totalItems} results
              </div>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => handlePageChange(page - 1)}
                  disabled={page === 1}
                  className="p-2 border border-border rounded-md bg-card text-muted-foreground hover:bg-accent hover:text-foreground disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  <ChevronLeft size={16} />
                </button>

                <div className="flex items-center space-x-1">
                  {[...Array(pagination.totalPages)].map((_, idx) => {
                    const pageNum = idx + 1;
                    const current = pagination.currentPage;

                    // Show first, last, current, and adjacent pages
                    if (
                      pageNum === 1 ||
                      pageNum === pagination.totalPages ||
                      (pageNum >= current - 1 && pageNum <= current + 1)
                    ) {
                      return (
                        <button
                          key={pageNum}
                          onClick={() => handlePageChange(pageNum)}
                          className={`min-w-[2rem] px-3 py-1 text-sm rounded-md transition-colors ${
                            pageNum === current
                              ? "bg-primary text-primary-foreground font-medium"
                              : "bg-card text-muted-foreground hover:bg-accent hover:text-foreground border border-border"
                          }`}
                        >
                          {pageNum}
                        </button>
                      );
                    } else if (
                      pageNum === current - 2 ||
                      pageNum === current + 2
                    ) {
                      return (
                        <span key={pageNum} className="text-muted-foreground">
                          ...
                        </span>
                      );
                    }
                    return null;
                  })}
                </div>

                <button
                  onClick={() => handlePageChange(page + 1)}
                  disabled={page === pagination.totalPages}
                  className="p-2 border border-border rounded-md bg-card text-muted-foreground hover:bg-accent hover:text-foreground disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  <ChevronRight size={16} />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Booking;
